export default "__VITE_ASSET__0cc3ec01__"